import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Part2.css';
import { HomeContext } from '../../Context/HomeContext';
import { FaCalendarAlt, FaEye } from 'react-icons/fa';

const ThreeColumnLayout = () => {
  const { homeData, loading } = useContext(HomeContext);
  const blogs = homeData?.todayTopBlogs || [];

  const categories = [...new Set(blogs.map(blog => blog.category?.name))].filter(Boolean).slice(0, 2);

  const blogsByCategory = (catName) =>
    blogs.filter(b => b.category?.name === catName).slice(0, 3);

  const featuredBlog = blogs.find(
    b => !categories.includes(b.category?.name)
  ) || blogs[0];

  const formatDate = (dateStr) => {
    const published = new Date(dateStr);
    return published.toLocaleDateString();
  };

  // 🔄 Show Bootstrap Spinner if loading
  if (loading || blogs.length === 0) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
        <div className="loader-text">Loading Section...</div>
      </div>
    );
  }

  return (
    <div className="container py-4">
      <div className="row">
      <h3 className="fw-bold mb-4 border-bottom pb-2">Today Blogs</h3>
        {/* LEFT COLUMN */}
        <div className="col-lg-4 col-md-6 mb-4">
          <h5 className="fw-bold pb-3">{categories[0]?.toUpperCase()} &gt;</h5>
          <div className="d-flex flex-column gap-3">
            {blogsByCategory(categories[0]).map((item) => (
              <NavLink to={`/blog/${item.slug}`} key={item.id} className="text-decoration-none text-dark">
                <div className="d-flex justify-content-between align-items-start border-bottom pb-2">
                  <div className="pe-2">
                    <p className="mb-1 fw-semibold">{item.title}</p>
                    <small className="text-muted">
                      <FaCalendarAlt/> {formatDate(item.published_at)} &nbsp;&nbsp; <FaEye/> {item.views_count} views
                    </small>
                  </div>
                  <img
                    src={`https://api.funfillia.com/${item.image_200x200}`}
                    alt={item.title}
                    width="60"
                    height="60"
                    className="rounded hover-zoom"
                  />
                </div>
              </NavLink>
            ))}
          </div>
        </div>

        {/* MIDDLE COLUMN */}
        <div className="col-lg-4 col-md-6 mb-4">
          <h5 className="fw-bold">{categories[1]?.toUpperCase()} &gt;</h5>
          <div className="d-flex flex-column gap-3">
            {blogsByCategory(categories[1]).map((item) => (
              <NavLink to={`/blog/${item.slug}`} key={item.id} className="text-decoration-none text-dark">
                <div className="d-flex justify-content-between align-items-start border-bottom pb-2">
                  <div className="pe-2">
                    <p className="mb-1 fw-semibold">{item.title}</p>
                    <small className="text-muted">
                      <FaCalendarAlt/> {formatDate(item.published_at)} &nbsp;&nbsp; <FaEye/> {item.views_count} views
                    </small>
                  </div>
                  <img
                    src={`https://api.funfillia.com/${item.image_200x200}`}
                    alt={item.title}
                    width="60"
                    height="60"
                    className="rounded hover-zoom"
                  />
                </div>
              </NavLink>
            ))}
          </div>
        </div>

        {/* RIGHT COLUMN: FEATURED BLOG */}
        <div className="col-lg-4 col-12 mb-4">
          {featuredBlog && (
            <NavLink to={`/blog/${featuredBlog.slug}`} className="text-decoration-none text-white">
              <div
                className="position-relative rounded hover-zoom"
                style={{
                  backgroundImage: `url(https://api.funfillia.com/${featuredBlog.image_850x500})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  height: '350px',
                  transition: 'transform 0.3s ease'
                }}
              >
                <div className="position-absolute bottom-0 start-0 w-100 bg-dark bg-opacity-50 text-white p-3">
                  <small>
                    <FaCalendarAlt/> {formatDate(featuredBlog.published_at)} &nbsp;&nbsp; <FaEye/> {featuredBlog.views_count} views
                  </small>
                  <h5 className="fw-bold mb-1">{featuredBlog.title}</h5>
                </div>
              </div>
            </NavLink>
          )}
        </div>
      </div>
    </div>
  );
};

export default ThreeColumnLayout;
